import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import banner1 from "../assets/banners/r1.jpg";
import banner2 from "../assets/banners/r2.jpg";
import banner3 from "../assets/banners/r3.jpg";
import banner4 from "../assets/banners/r4.jpg";
import banner5 from "../assets/banners/r5.jpg";

import banner6 from "../assets/banners/r6.jpg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import './HomeStyle.css';

function Home() {
  const [showHeader, setShowHeader] = useState(false);

  // ✅ Toggle header visibility on scroll
  useEffect(() => {
    const handleScroll = () => {
      setShowHeader(window.scrollY > 500);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const heroSlides = [
    { image: banner1, buttonText: "", buttonLink: "/" },
  ];

  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    arrows: true,
  };

  return (
    <div className="home-container">
      {/* Hero Section */}
      <section className=" hero-slider">
        <Slider {...sliderSettings}>
          {heroSlides.map((slide, index) => (
            <div key={index} className="hero-slide">
              <img src={slide.image} alt={`Slide ${index + 1}`} className="hero-image" />
              <div className=" hero-overlay">
              </div>
            </div>
          ))}
        </Slider>
      </section>



{/* Section */}
      <section className="w3-row w3-padding-64">
        <div className="w3-col ">
        </div>
      </section>




{/* Section */}
      <section className="w3-row ">
        <div className="w3-col ">
          <div className="w3-col l6">
            <img src={banner2} alt="" className="hero-image" />
          
          </div>
          <div className="w3-col l5 w3-padding-64">
          
          </div>
        </div>
      </section>



{/* Section */}
      <section className="w3-row">
        <div className="w3-col ">
          <div className="w3-col l6 w3-right">
            <img src={banner3} alt="" className="hero-image" />
          
          </div>
          <div className="w3-col l5 ">
          
          </div>
        </div>
      </section>


{/* Section */}
      <section className="w3-row">
        <div className="w3-col ">
          <div className="w3-col l6">
            <img src={banner4} alt="" className="hero-image" />
          
          </div>
          <div className="w3-col l5 w3-padding-64">
          
          </div>
        </div>
      </section>

{/* Section */}
      <section className="w3-row">
        <div className="w3-col ">
          <div className="w3-col l6 w3-right">
            <img src={banner5} alt="" className="hero-image" />
          
          </div>
          <div className="w3-col l5 w3-padding-64">
          
          </div>
        </div>
      </section>


{/* Section */}
      <section className="w3-row">
        <div className="w3-col ">
          <div className="w3-col l6">
            <img src={banner6} alt="" className="hero-image" />
          
          </div>
          <div className="w3-col l5 w3-padding-64">
          
          </div>
        </div>
      </section>

    </div>
  );
}

export default Home;
